import styled, { css } from 'styled-components';
import { lazy, Suspense, ReactNode } from 'react';

// Loaded only when a deal line is shown, so screens without deal lines (and
// their tests) never load the deals API.
const Caption = lazy(() => import('./caption'));

// The caption sits under the product name. On a tablet the receipt card puts
// the Item heading beside another cell's heading, so there it stays on the
// name's line and a deal line is exactly as tall as any other; a long name
// ends in an ellipsis.
const Line = styled.div`
  min-width: 0;
  display: flex;
  ${({ theme }) =>
    theme.responsive.isTablet
      ? css`
          gap: 8px;
          align-items: baseline;
        `
      : css`
          gap: 4px;
          flex-direction: column;
        `}
`;

const Name = styled.span`
  flex-shrink: 0;
  ${({ theme }) =>
    theme.responsive.isTablet &&
    css`
      white-space: nowrap;
    `}
`;

interface WithDealCaptionProps {
  children: ReactNode;
  dealId?: number | null;
}

// POS Deals (26 Oct 2026): a sold line that came from a deal shows
// "Deal: <name>" after the product; any other line renders exactly as before.
export const WithDealCaption = ({ dealId, children }: WithDealCaptionProps) =>
  dealId ? (
    <Line>
      <Name>{children}</Name>
      <Suspense fallback={null}>
        <Caption dealId={dealId} />
      </Suspense>
    </Line>
  ) : (
    <>{children}</>
  );
